'use strict';

const React = require('react');

class Hotjar extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    return null;
  }

}

module.exports = Hotjar;
